import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const state = {
  member_token: ''
}

const mutations = {
  changeMemberToken(state, token) {
    state.member_token = token
  }
}

const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      reducer(val) {
        return {
          // 只持久化储存state中的mohou_token等
          member_token: val.member_token
        }
      }
    })
  ],
  state: state,
  mutations: mutations
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js